import ComplaintSeverity from '@/models/complaints/complaint-severity'
import { IComplaintState } from './interfaces/complaint-state'

export default class ComplaintState implements IComplaintState {
  public complaintSeverities: ComplaintSeverity[] = []
}
